// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AuctionPurchase } from './auction-purchase';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AuctionItem extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
    // return `${this.auctionNumber} --- ${this.name}`;
    return `${this.name}`;
  }

  get typeNumberDispalyName() {
    return `${this.type ? this.type[0].toUpperCase() : '???'}-${this.id.toString().padStart(3, '0')}`;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  auctionNumber!: number;
  closed?: Date;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  donatedBy?: string;
  isDonationQualified!: boolean;
  linePrice?: number;
  marketValue?: number;
  minimumBid?: number;
  name?: string;
  type?: string;
  purchases!: AuctionPurchase[];
}

